"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatErrorMessage = void 0;
const formatErrorMessage = function ({ code }) {
    const almostFormattedErrorMessage = code.
        split('').
        map((character, index) => {
        if (index === 0) {
            return character.toUpperCase();
        }
        if (character.toUpperCase() === character) {
            return ` ${character.toLowerCase()}`;
        }
        return character;
    }).
        join('');
    return `${almostFormattedErrorMessage}.`;
};
exports.formatErrorMessage = formatErrorMessage;
